import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';

// Resets scroll to the top of the page whenever the route changes.
// React Router preserves scroll position across navigations by default, which
// made pages open part-way down (wherever the previous page was scrolled).
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: 'auto' });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
